import styled from "styled-components";

export const StyledWarning = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: 20px;
  margin-right: 30px;
`;